import React, { useEffect } from 'react';
import { useRouter } from 'next/router';
import Layout from '@common/layout';
import Content from '@common/content';
import Footer from '@components/common/footer';
import { SearchResultCustomHead } from '@components/common/customHead';
import Header from '@components/common/header';
import Search from '@components/search';
import UrlUtil from '@utils/urlUtil';

const SearchPage = () => {
  const { query } = useRouter();
  const keyword = Array.isArray(query.keyword) ? query.keyword[0] : query.keyword;

  useEffect(() => {
    if (keyword === undefined) {
      return;
    }

    if (keyword === '') {
      UrlUtil.removeQueryStringAndReplace('keyword');
    }
  }, [keyword]);

  return (
    <Layout>
      <Header />
      <SearchResultCustomHead keyword={keyword} />
      <Content>
        <Search />
      </Content>
      <Footer />
    </Layout>
  );
};

export default SearchPage;
